"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GitStatusShortFormat = void 0;
// See https://git-scm.com/docs/git-status#_short_format
var GitStatusShortFormat;
(function (GitStatusShortFormat) {
    GitStatusShortFormat["UnModified"] = "";
    GitStatusShortFormat["Modified"] = "M";
    GitStatusShortFormat["Added"] = "A";
    GitStatusShortFormat["Deleted"] = "D";
    GitStatusShortFormat["Renamed"] = "R";
    GitStatusShortFormat["Copied"] = "C";
    /**
     * Updated but not merged
     */
    GitStatusShortFormat["Updated"] = "U";
    /**
     * New files that have never been committed before
     */
    GitStatusShortFormat["Untracked"] = "?";
})(GitStatusShortFormat || (exports.GitStatusShortFormat = GitStatusShortFormat = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2l0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21lc3NhZ2VzL2dpdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFLQSx3REFBd0Q7QUFDeEQsSUFBWSxvQkFlWDtBQWZELFdBQVksb0JBQW9CO0lBQzlCLHVDQUFlLENBQUE7SUFDZixzQ0FBYyxDQUFBO0lBQ2QsbUNBQVcsQ0FBQTtJQUNYLHFDQUFhLENBQUE7SUFDYixxQ0FBYSxDQUFBO0lBQ2Isb0NBQVksQ0FBQTtJQUNaOztPQUVHO0lBQ0gscUNBQWEsQ0FBQTtJQUNiOztPQUVHO0lBQ0gsdUNBQWUsQ0FBQTtBQUNqQixDQUFDLEVBZlcsb0JBQW9CLG9DQUFwQixvQkFBb0IsUUFlL0IifQ==